import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { EnvironmentGuardService } from 'src/app/guards/environment-guard.service';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

@Injectable()
export class StagingGuardService extends EnvironmentGuardService {
  constructor(router: Router, appConfigService: AppConfigService) {
    super(router, appConfigService.config.staging);
  }
}
